import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async get(id: number) {
    return wrapEndpoint(() => client.GET('/medicine-presentation/{id}', { params: { path: { id } } }))
  },

  async list(options?: ApiSchemas['ListMedicinePresentationDto']) {
    return wrapEndpoint(() => client.GET('/medicine-presentation', { params: { query: options } }))
  },

  async create(data: ApiSchemas['CreateMedicinePresentationDto']) {
    return wrapEndpoint(() => client.POST('/medicine-presentation', { body: data }))
  },

  async update(id: number, data: ApiSchemas['UpdateMedicinePresentationDto']) {
    return wrapEndpoint(() => client.PUT('/medicine-presentation/{id}', { body: data, params: { path: { id } } }))
  },

  async delete(id: number) {
    await wrapEndpoint(() => client.DELETE('/medicine-presentation/{id}', { params: { path: { id } } }))
  },
}
